import UserPermissionsDomainActionTypes from './action-types';

const initialState = {
  userPermissionsDomain: [],
};

// eslint-disable-next-line default-param-last
const userPermissionsDomainReducer = (state = initialState, action) => {
  switch (action.type) {
    case UserPermissionsDomainActionTypes.USER_PERMISSIONS_DOMAIN:
      if (!action.payload) {
        return { ...state, userPermissionsDomain: ['user'] };
      }
      return { ...state, userPermissionsDomain: action.payload };
    default:
      return state;
  }
};

export default userPermissionsDomainReducer;
